import {
  GET_ALL_PROPERTIES,
  GET_PROPERTY_DETAILS,
  GET_APPLIED_USERS_FOR_PROPERTY,GET_ADMIN_PROPERTIES_LIST,GET_COMMENT_LIST
} from "./actions";

const initialState = {
  propertyList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  adminPropertyList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  propertyAppliedUsersList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  commentList:[],
  propertyData: {},
  loading: true,
};

const propertyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_PROPERTIES:
      return {
        ...state,
        propertyList: payload,
        loading: false,
      };
    case GET_ADMIN_PROPERTIES_LIST:
      return {
        ...state,
        adminPropertyList: payload,
        loading: false,
      };
    case GET_COMMENT_LIST:
      return{
        ...state,
        commentList:payload
      }
    case GET_PROPERTY_DETAILS:
      return {
        ...state,
        propertyData: payload,
        loading: false,
      };
    case GET_APPLIED_USERS_FOR_PROPERTY:
      return {
        ...state,
        propertyAppliedUsersList: payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default propertyReducer;
